import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Arabic: IconDef = {
  svg: (
    <G>
      <Path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <Path
        d="M12.0002 -0.000305176C6.84061 -0.000305176 2.4421 3.25619 0.746582 7.8258H23.2538C21.5583 3.25619 17.1598 -0.000305176 12.0002 -0.000305176Z"
        fill="#D80027"
      />
      <Path
        d="M12.0002 24.0003C17.1598 24.0003 21.5583 20.7438 23.2538 16.1742H0.746582C2.4421 20.7438 6.84061 24.0003 12.0002 24.0003Z"
        fill="black"
      />
      <Path
        d="M16.1738 10.6956H13.0433C13.0433 10.1193 12.5761 9.65213 11.9999 9.65213C11.4236 9.65213 10.9564 10.1193 10.9564 10.6956H7.82593C7.82593 11.2719 8.32791 11.7391 8.90419 11.7391H8.86941C8.86941 12.3154 9.33657 12.7826 9.91289 12.7826C9.91289 13.3589 10.3801 13.8261 10.9564 13.8261H13.0433C13.6197 13.8261 14.0868 13.3589 14.0868 12.7826C14.6632 12.7826 15.1303 12.3154 15.1303 11.7391H15.0956C15.6719 11.7391 16.1738 11.2719 16.1738 10.6956Z"
        fill="#FF9811"
      />
    </G>
  ),
  svgStyles() {
    return {};
  },
};
